import { z } from 'zod';
/** How much of a block's payload a flow run response carries. */
export var FlowRunBlockDataVariant;
(function (FlowRunBlockDataVariant) {
    FlowRunBlockDataVariant["None"] = "None";
    FlowRunBlockDataVariant["Redacted"] = "Redacted";
    FlowRunBlockDataVariant["AllIncludingPotentialPhi"] = "AllIncludingPotentialPhi";
})(FlowRunBlockDataVariant || (FlowRunBlockDataVariant = {}));
/**
 * Query parameter the endpoints returning block payloads accept.
 *
 * Payloads are redacted by default to protect patient privacy; asking for
 * `AllIncludingPotentialPhi` is what an audited, unredacted read looks like.
 */
export const FlowRunBlockDataVariantQuerySchema = z.strictObject({
    dataVariant: z
        .enum(FlowRunBlockDataVariant)
        .describe('How much of each block payload to return. Defaults to Redacted.')
        .optional(),
});
//# sourceMappingURL=blockDataVariant.js.map